//TODO: Delete this file after rewriting the old admin pages to React.
// Responsible for closing old modal windows after a successful request

$(document).ready(function () {
  $(document).bind("ajaxError", "form.ajax-error", function (event, jqxhr) {
    // debugger;

    // note: jqxhr.responseJSON undefined, parsing responseText instead
    $(event.data).render_form_errors($.parseJSON(jqxhr.responseText));
  });

  // clear errors in forms
  $("body").on("hidden.bs.modal", ".modal", function () {
    $(".modal").clear_previous_errors();
  });
});

(function ($) {
  $.fn.modal_success = function () {
    // close modal
    this.modal("hide");

    // clear form input elements
    // todo/note: handle textarea, select, etc
    // this.find('form input[type="text"]').val('');

    // clear error state
    this.clear_previous_errors();
  };

  $.fn.render_form_errors = function (errors) {
    // $form = this;
    this.clear_previous_errors();
    // model = this.data('model');

    // debugger;

    // show error messages in input form-group help-block
    $.each(errors, function (field, messages) {
      // debugger;

      // $input = $('input[name="' + field + '"]');
      const $input = $("input." + field);
      $input
        .closest(".control-group")
        .addClass("has-error")
        .find(".help-block")
        .html(messages.join(" & "));

      // $select = $('select[name="' + field + '"]');
      const $select = $("select." + field);
      $select
        .closest(".control-group")
        .addClass("has-error")
        .find(".help-block")
        .html(messages.join(" & "));
    });
  };

  $.fn.clear_previous_errors = function () {
    $(".control-group.has-error", this).each(function () {
      $(".help-block", $(this)).html("");
      $(this).removeClass("has-error");
    });
  };
})(jQuery);
